import axios from "axios";
import { API_URL } from "../utils/constants";
import { addLanguage } from "../pages/profile/types";
import { axiosInstance } from "./httpClient";
interface comsBody {
  toolName: string;
  toolUrl: string;
}

const getToken = () => {
  return localStorage.getItem("token");
};

const getMerchantId = () => {
  return localStorage.getItem("id");
};

//add the comunication tools of choice
export const handleComs = async (body: comsBody) => {
  let token = getToken();
  const response = await axiosInstance.post(`${API_URL}/teachers/communication-tools`, body, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return response;
};

export const getComms = async () => {
  let merchantId = getMerchantId();
  let token = getToken();
  const response = await axiosInstance.get(
    `${API_URL}/teachers/communication-tools/${merchantId}`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
  return response;
};

export const deleteComms = async (id: string) => {
  let token = getToken();
  const response = await axiosInstance.delete(`${API_URL}/teachers/communication-tools/${id}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return response;
};

export const setLanguages = async (payload: addLanguage) => {
  let token = getToken();
  let id = getMerchantId();
  const response = await axiosInstance.post(
    `${API_URL}/teachers/${id}/language-update`,

    payload,
    {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    }
  );
};

export const getSpoken = async () => {
  let id = getMerchantId();
  let token = getToken();
  const response = await axiosInstance.get(`${API_URL}/teachers/${id}/languages-spoken`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response;
};

export const getTaught = async () => {
  let id = getMerchantId();
  let token = getToken();
  const response = await axiosInstance.get(`${API_URL}/teachers/${id}/languages-taught`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response;
};